// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3CzHW","info":"UpdateTermsInfo_info__35snp"};